import log from 'util/log';
import { rehydrateState } from './saved-state';

const SAVED_KEY = '__PRODUCT_STATE__';
const DB = '__PRODUCT_DB__';
const DB_PROMISE = '__PRODUCT_PROMISE__';
const ENDPOINT = '/products.json';

export const getProducts = () => {
  log.info("DB: getProducts");
  const products = window[DB];
  if (products) {
    log.info("DB: Products already resolved");
    return Promise.resolve(products);
  }

  log.info("DB: Products not yet resolved, do we have a promise yet?");
  if (!window[DB_PROMISE]) {
    log.info("DB: No, we don't have a promise, let's check for hydrated state");
    window[DB_PROMISE] = Promise.resolve(rehydrateState(
      SAVED_KEY,
      () => {
        log.info("DB: Fetching product list from server");
        return fetch(ENDPOINT)
          .then(result => result.json())
          .catch(error => {
            log.error('DB: Failed to get products', error);
            return [];
          });
      },
      () => window[DB],
      () => {
        log.info("DB: No hyrdated state");
      }
    ))
    .then((result) => {
      log.info("DB: Promise resolved, so update the DB and delete the promise");
      window[DB] = result;
      delete window[DB_PROMISE];
      return result;
    });
  }

  log.info("DB: We should have a promise now, so we'll return it");
  return window[DB_PROMISE];
};

export const getProductById = async (id) => {
  const productList = await getProducts();
  return productList.find(product => product.id === id);
}

export const getProductImageUrl = ( image, size ) => `/images/product/resize/${size}/${image.baseName}-${size}.jpg`;

export const getProductPreviewImageUrl = (product, size) =>
  getProductImageUrl(product.images[product.preview], size);

export const getProductPriceString = (product) => `$${(product.price / 100).toFixed(2)}`;



// WEBPACK FOOTER //
// ./src/service/products.js